/**
 * SectionSwitcher - singleton class, which allows switch between different tables
 * on the page. You can see example on the page /jobs-flow
 */

import { CRUDFabric } from "../CRUDs/CRUDFabric.js";
import { Accident } from "../CRUDs/entities/Accident.js";
import { Alarm } from "../CRUDs/entities/Alarm.js";
import { Customer } from "../CRUDs/entities/Customer";
import { Invoice } from "../CRUDs/entities/Invoice.js";
import { JobRequest } from "../CRUDs/entities/JobRequest";
import { MaintenanceReport } from "../CRUDs/entities/MaintenanceReport.js";
import { Quote } from "../CRUDs/entities/Quote.js";
import { Vehicle } from "../CRUDs/entities/Vehicle.js";
import { VehicleInvoice } from "../CRUDs/entities/VehicleInvoice.js";
import { removeQueryParams, setQueryParams } from "./Filter";
import { Section } from "./Section";

export const SectionSwitcher = (() => {

    let instance = null;
    let sectionsList = [];

    // Tab-system helpers: support BOTH the legacy tab (.section, name-class, .selected)
    // and the converted component tab (.subtab, data-section, .on) so pages can migrate
    // one at a time without breaking this shared switcher.
    const $tabs = () => $('.section, .subtab');
    const $tabByTitle = (t) => $(`.subtab[data-section="${t}"], .sections .section.${t}`);
    const titleOf = (el) => {
        const ds = (el.getAttribute('data-section') || '').trim();
        if (ds) return ds;
        const cl = el.classList.value.trim().split(/\s+/);
        const last = cl.pop();
        return (last === 'selected' || last === 'on') ? cl.pop() : last;
    };
    const setActiveTab = (t) => {
        $('.section').removeClass('selected');
        $('.subtab').removeClass('on');
        $(`.sections .section.${t}`).addClass('selected');
        $(`.subtab[data-section="${t}"]`).addClass('on');
    };

    const initSectionList = () => {
        if (location.pathname.includes('/settings/website-builder')) {
            sectionsList.push(new Section('website-builder'));
        } else {
            $tabs().toArray().map((section) => {
                sectionsList.push(new Section(titleOf(section)));
            });
        }
    }

    const getSelectedSectionTitle = () => {
        const active = $('.subtab.on, .section.selected')[0];
        return active ? titleOf(active) : null;
    }

    const showCreateLinksForSelectedSection = (section) => {
        $('.modal-window-actions').removeClass('d-flex');
        $('.modal-window-actions').addClass('d-none');

        const link1 = $('.action.custom-action.link1').off();
        const linkHeader1 = $('.action.custom-action.header-action').off();
        let callback1

        const link2 = $('.action.custom-action.link2').off();
        const linkHeader2 = $('.action.custom-action.header-action').off();
        let callback2

        switch (section) {
            case 'customers':
                link1.attr('data-action', 'create')
                    .attr('data-class', 'customer');
                link1.find('.button-title').text('New Customer');
                linkHeader1.text(`+ New customer`)
                callback1 = (e) => {
                    const staticCustomer = new Customer();
                    staticCustomer.openModal('create');
                }
                link2.attr('data-action', 'create')
                    .removeAttr('data-class');
                link2.find('.button-title').text('New Request');
                linkHeader2.text(`+ New Request`)
                callback2 = (e) => {
                    const staticRequest = new JobRequest();
                    staticRequest.openModal('create');
                }
            case 'requests':
                link1.attr('data-action', 'create')
                    .attr('data-class', 'customer');
                link1.find('.button-title').text('New Customer');
                linkHeader1.text(`+ New customer`)
                callback1 = (e) => {
                    const staticCustomer = new Customer();
                    staticCustomer.openModal('create');
                }
                link2.attr('data-action', 'create')
                    .removeAttr('data-class');
                link2.find('.button-title').text('New Request');
                linkHeader2.text(`+ New Request`)
                callback2 = (e) => {
                    const staticRequest = new JobRequest();
                    staticRequest.openModal('create');
                }
                break;
            case 'visits':
                link1.attr('data-action', 'create')
                    .attr('data-class', 'customer');
                linkHeader1.text(`+ New customer`)
                link1.find('.button-title').text('New Customer');
                callback1 = (e) => {
                    const staticCustomer = new Customer();
                    staticCustomer.openModal('create');
                }
                link2.attr('data-action', 'create')
                    .removeAttr('data-class');
                linkHeader2.text(`+ New Request`)
                link2.find('.button-title').text('New Request');
                callback2 = (e) => {
                    const staticRequest = new JobRequest();
                    staticRequest.openModal('create');
                }
                break;
            case 'quotes':
                link1.attr('data-action', 'create')
                    .attr('data-class', 'customer');
                linkHeader1.text(`+ New customer`)
                callback1 = (e) => {
                    const staticCustomer = new Customer();
                    staticCustomer.openModal('create');
                }
                link1.find('.button-title').text('New Customer');
                link2.removeAttr('data-class')
                    .removeAttr('data-action');
                linkHeader2.text(`+ Add Quote`)
                link2.find('.button-title').text('New Estimate');
                callback2 = () => {
                    const quote = new Quote()
                    quote.openModal('confirm-action');
                    //window.open('/jobs-flow/quote/create', '_blank')
                }
                break;

            case 'jobs':
                link1.attr('data-action', 'create')
                    .attr('data-class', 'customer');
                linkHeader1.text(`+ New customer`)
                link1.find('.button-title').text('New Customer');
                callback1 = (e) => {
                    const staticCustomer = new Customer();
                    staticCustomer.openModal('create');
                }
                link2.attr('data-action', 'create')
                    .removeAttr('data-class');
                linkHeader2.text(`+ New Request`)
                link2.find('.button-title').text('New Request');
                callback2 = (e) => {
                    const staticRequest = new JobRequest();
                    staticRequest.openModal('create');
                }
                break;
            case 'invoices':
                link1.attr('data-action', 'create')
                    .attr('data-class', 'customer');
                linkHeader1.text(`+ New customer`)
                link1.find('.button-title').text('New Customer');
                callback1 = (e) => {
                    const staticCustomer = new Customer();
                    staticCustomer.openModal('create');
                }
                link2.removeAttr('data-class')
                    .removeAttr('data-action');
                linkHeader2.text(`+ New Invoice`)
                link2.find('.button-title').text('New Invoice');
                callback2 = () => {
                    const invoice = new Invoice()
                    invoice.openModal('confirm-action');
                    //window.open('/jobs-flow/invoice/create', '_blank')
                }
                break;
            case 'vehicles':
                link1.removeAttr('data-class')
                    .removeAttr('data-action')
                    .removeClass('d-none')
                    .find('.button-title').text('Add Vehicle');
                linkHeader1.text(`+ Add Vehicle`)
                callback1 = ()=>{
                    const vehicle = new Vehicle()
                    vehicle.openModal('create')
                }

                link2.addClass('d-none');

                break;
            case 'maintenance-reports':
                link1.removeAttr('data-class')
                    .removeAttr('data-action')
                    .removeClass('d-none')
                    .find('.button-title').text('Add Report');
                linkHeader1.text(`+ Add Report`)
                callback1 = ()=>{
                    const vehicle = new MaintenanceReport();
                    vehicle.openModal('create')
                }

                link2.removeAttr('data-class')
                    .removeAttr('data-action')
                    .removeClass('d-none');
                break;
            case 'alarms':
                link1.removeAttr('data-class')
                    .removeAttr('data-action')
                    .removeClass('d-none')
                    .find('.button-title').text('Add Alarm');
                linkHeader1.text(`+ Add Alarm`)
                callback1 = ()=>{
                    const vehicle = new Alarm()
                    vehicle.openModal('create')
                }

                link2.addClass('d-none');

                break;
            case 'vehicle-invoices':
                link1.removeAttr('data-class')
                    .removeAttr('data-action')
                    .removeClass('d-none')
                    .find('.button-title')
                    .text('New Invoice')
                    .data('action', 'vehicle-invoice');
                linkHeader1.text(`+ New Invoice`)
                callback1 = ()=>{
                    const vehicle = new VehicleInvoice()
                    vehicle.openModal('create')
                }

                link2.addClass('d-none');

                break;
            case 'repairs':
                link1.addClass('d-none');
                // linkHeader1.addClass('d-none');
                break;
            case 'accidents':
                link1.removeAttr('data-class')
                    .removeAttr('data-action')
                    .removeClass('d-none')
                    .find('.button-title').text('Create Report');
                linkHeader1.text(`+ Create Report`)
                callback1 = ()=>{
                    const vehicle = new Accident();
                    vehicle.openModal('create')
                }

                link2.addClass('d-none');

                break;
            default:
                callback1 = function() {
                    const entityClass = this.getAttribute('data-class') ?? section;
                    const entity = CRUDFabric.getObject(entityClass);
                    entity.openModal(link1.data('action'));
                }
                break;
        }

        if(typeof callback1 === 'function'){
            link1.off('click').on('click', callback1);
            linkHeader1.off('click').on('click', callback1)
        }

        if(typeof callback2 === 'function') {
            link2.off('click').on('click', callback2);
            linkHeader2.off('click').on('click', callback2)
        }
    }

    return class SectionSwitcher {
        constructor() {
            if (instance === null) {
                instance = this;
                this.init();
            }
            return instance;
        }
        init() {
            initSectionList();

            if (sectionsList.length>0) {
                this.showSelectedSection();
                this.sectionSwitcherListners();
            }
        }

        /**
         * return selected section
         *
         * @returns Section
         */
        getSelectedSection = (sectionTitle=null) => {
            getSelectedSectionTitle();
            for (let section of sectionsList) {
                if (!section.container.hasClass('d-none')) return section;
            }
        }

        hideAll() {
            sectionsList.forEach((section) => {
                section.hide();
            });

            return this;
        }

        /**
         * Show section with attribute "selected" or with given section name
         *
         * @param { string|null } section
         */

        showSelectedSection(sectionTitle=null) {

            const selectedSectionTitle = sectionTitle ?? getSelectedSectionTitle();

            if(selectedSectionTitle){
                const section = SectionSwitcher.getSectionByTitle(selectedSectionTitle);
                if(!section) return

                $(`.data-view.${selectedSectionTitle}`).removeClass('d-none');
                $(`.data-view.${selectedSectionTitle}`).addClass('d-block');

                $(`.data-view.${selectedSectionTitle}`).find('.data-row').removeClass('d-none');

                let parentSection = $tabByTitle(selectedSectionTitle).data('parent-section')

                setActiveTab(selectedSectionTitle);
                if(parentSection){
                    $(`#${parentSection}`).addClass('selected');
                }

                if (['jobs','requests','visits','invoices','quotes'].includes(selectedSectionTitle)) {
                    $('.sub-sections').removeClass('d-none');
                } else if (selectedSectionTitle == 'orders' || selectedSectionTitle == 'paymethods') {
                    $('.sub-sections').addClass('d-none');
                }

                this.hideAll();
                section.show();

                showCreateLinksForSelectedSection(selectedSectionTitle);
                $('.modal-window-actions').css('display', 'none');

                if (selectedSectionTitle === "jobs_top") $(".section.jobs").trigger('click')
                document.dispatchEvent(new CustomEvent('show_section',{detail:{switcher:this, selected:selectedSectionTitle}}))
                return this.getSelectedSection();
            }
        }

        choseSection(clickElement){
            $('.section').removeClass('selected');
            $('.subtab').removeClass('on');
            const $clicked = $(clickElement);
            if ($clicked.hasClass('section') || $clicked.hasClass('subtab')) {
                $clicked.addClass($clicked.hasClass('subtab') ? 'on' : 'selected');
                removeQueryParams();
                const sectionTitle = getSelectedSectionTitle();

                if (window.location.pathname.includes('/jobs-flow')) {
                    $('.quotes-cards, .invoices-cards').addClass('d-none');

                    if (sectionTitle === 'quotes') {
                        $('.bb-standard-title').text('Estimates');
                        $('.quotes-cards').removeClass('d-none');
                    } else if (sectionTitle === 'invoices') {
                        $('.bb-standard-title').text('Invoices');
                        $('.invoices-cards').removeClass('d-none');
                    } else if (sectionTitle === 'visits') {
                        $('.bb-standard-title').text('Visits');
                    } else if (sectionTitle === 'requests') {
                        $('.bb-standard-title').text('Requests');
                    } else if (sectionTitle === 'customers') {
                        $('.bb-standard-title').text('Customers');
                    } else {
                        $('.bb-standard-title').text('Jobs');
                    }
                }

                setQueryParams({'entity_class': sectionTitle});
            } else {
                let elem = $(clickElement).closest('.section, .subtab')[0];
                if (elem) $(elem).addClass($(elem).hasClass('subtab') ? 'on' : 'selected');
            }
        }

        sectionSwitcherListners = () => {
            $tabs().off();
            $tabs().on('click', (e) => {
                this.choseSection(e.currentTarget);
                this.showSelectedSection();
            });
        }

        static getSectionByTitle = (title) => {
            for (let section of sectionsList)
                if (section.title == title) return section;

        }

        static start(need_css = true) {
            const switcher = new SectionSwitcher();

            if (need_css) {
                $('.data-tables').css('display', 'flex');
                $('.wrapper-view').css({'padding': '15px 0 0 0', 'height': 'unset'});
                // Не скрываем прелоадер по таймауту, если в URL есть entity_class — данные ещё грузятся
                const urlParams = new URLSearchParams(window.location.search);
                if (!urlParams.get('entity_class')) {
                    setTimeout(() => {
                        const preloader = document.querySelector('#data-tables .preloader');
                        if (preloader)
                            preloader.style.display = 'none';
                    }, 500);
                }
            }

            return switcher;
        }

        static updateSection(sectionTitle) {
            const section = SectionSwitcher.getSectionByTitle(sectionTitle);
            section.update();
        }
    }
})();
